<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-card class="picture-div">
          <div
            style="height: 250px; padding-top: 50px"
            v-if="loadingData"
            class="loading"
          >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <div class="container">
              <img
                :src="partData.image"
                alt="fibernode.com"
                style="max-height:250px; display:block; margin: auto"
              />
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col lg="6">
        <b-card class="information" header="data">
          <div slot="header">
            <h5 style="display: inline;" class="card-title mb-0">
              Information
            </h5>
          </div>
          <div style="min-height: 200px">
            <span class="title-details">
              Model :
              <b>{{ partData.model }}</b>
            </span>
            <span class="title-details">
              Manufacturer :
              <b>{{ partData.make }}</b>
            </span>
            <span class="title-details">
              Product Type :
              <b>{{ partData.type }}</b>
            </span>
            <span class="title-details">
              Product Family :
              <b>{{ partData.family }}</b>
            </span>
            <span class="title-details">
              Product Description :
              <b>{{ partData.desc }}</b>
            </span>
            <span class="title-details">
              Manufacturer Part Number :
              <b>{{ partData.man_part }}</b>
            </span>
          </div>
        </b-card>
      </b-col>
      <ActiveBacklogModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></ActiveBacklogModel>
      <DeliveredModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></DeliveredModel>
      <BERModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></BERModel>
      <WARModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></WARModel>
    </b-row>
  </div>
</template>

<script>
import ActiveBacklogModel from "../../components/MODEL-ActiveBacklog";
import BERModel from "../../components/MODEL-BER";
import DeliveredModel from "../../components/MODEL-Delivered";
import WARModel from "../../components/MODEL-WAR";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  props: ["part"],
  name: "model",
  components: {
    ActiveBacklogModel,
    DeliveredModel,
    BERModel,
    WARModel
  },
  data: function() {
    return {
      loadingData: true,
      loadingProps: false,
      partParam: "",
      partData: []
    };
  },
  methods: {
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        fns_part: this.part
      };
      this.$http.get("api/fns/products/prodInfo.php", { params }).then(
        res => {
          this.partData = res.data[0];
          this.loadingData = false;
        },
        err => {
          console.log(err);
          this.loadingData = false;
        }
      );
    }
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.fetchData();
  }
};
</script>

<style>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
